import React, { Component } from "react";
import classnames from "classnames";
import { MechanismContainer } from "./style";
import { assetPromotionClassify } from "../../../utils/status";
import { objDeepCopy } from "../../../utils/tool";
import { observer } from "mobx-react";

@observer
class MechanismItem extends Component {
  constructor(props) {
    super(props);
    const { ClassifyItemPromotion } = this.props.store;
    const assetPromotionClassify = [
      {
        name: "全部",
        param: "",
        selected: true,
        condition: { organizationTypes: "none" },
      },
      {
        name: "审计机构",
        param: 1001,
        selected: false,
        condition: { organizationTypes: [1001] },
      },
      {
        name: "评估机构",
        param: 1002,
        selected: false,
        condition: { organizationTypes: [1002] },
      },
      {
        name: "拍卖机构",
        param: 1003,
        selected: false,
        condition: { organizationTypes: [1003] },
      },
      {
        name: "其他机构",
        param: 1004,
        selected: false,
        condition: { organizationTypes: [1004] },
      },
    ];
    if (ClassifyItemPromotion) {
      this.state = ClassifyItemPromotion;
    } else {
      this.state = {
        items: objDeepCopy(assetPromotionClassify),
      };
    }
  }

  componentDidMount() {}

  handleClick = (item) => {
    let curItem = {};
    const { items } = this.state;
    items.forEach((value, index) => {
      value.selected = false;
      if (index === item.index) {
        value.selected = true;
        curItem = value;
      }
    });
    this.setState({
      items,
    });

    // 暂存数据
    const { saveCurrData, addCondition } = this.props.store;
    const { closeFilter, defaultIndex, changeCurrFilterItems } = this.props;
    saveCurrData("ClassifyItemPromotion", this.state);

    // 增加选择条件
    addCondition(curItem.condition);
    closeFilter();
    changeCurrFilterItems(defaultIndex, item.name);
  };

  render() {
    const { items } = this.state;
    return (
      <MechanismContainer>
        <div className="mechanism-content">
          {items &&
            items.length &&
            items.map((item, index) => {
              return (
                <div className="mechanism-item-wrap" key={item.name}>
                  <div
                    className={classnames([
                      "mechanism-item",
                      {
                        actived: item.selected,
                      },
                    ])}
                    onClick={() => {
                      this.handleClick({
                        index,
                        id: item.param,
                        name: item.name,
                      });
                    }}
                  >
                    {item.name}
                  </div>
                </div>
              );
            })}
        </div>
      </MechanismContainer>
    );
  }
}

export default MechanismItem;
